<span>
  <span
    tooltip="{{ taxonName.rank }}"
    *ngFor="let taxonName of namesInReverse(); last as last"
    >{{ taxonName.partialName }}<span *ngIf="!last"> / </span></span
  >
</span>
